<app-loading type='LOADING_DATA' *ngIf="this.dietConsultationData.api_result.Posting"></app-loading>

<div class="ui-g"
    *ngIf="!this.dietConsultationData.api_result.Posting && this.dietConsultationData.api_result.PromiseResult.success">
    <div class="ui-g-12">
        <div class="ui-g">
            <div class="ui-g-12">
                <p class="egd-theme-text"><b>Health Goals</b></p>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <div class="ui-g-12">
                        <p class="format-lines description-text">
                            {{this.dietConsultationData.health_goal}}
                        </p>
                    </div>
                </div>
            </div>

        </div>
        <!-- <ng-container *ngIf="this.dietConsultationData.is_paid; else free_plan"> -->
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Diet Preference</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.final_diet_preferrence}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <!-- </ng-container> -->
        <!-- <ng-template #free_plan>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Breakfast</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Time (in 24-hrs format)</p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.breakfast.properties[0].time}}
                                </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Menu with portion size </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.breakfast.properties[0].quantity_description}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Lunch</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Time (in 24-hrs format)</p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.lunch.properties[0].time}}
                                </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Menu with portion size </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.lunch.properties[0].quantity_description}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Snack 1</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Time (in 24-hrs format)</p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.snack_1.properties[0].time}}
                                </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> List of Snacks & drinks </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.snack_1.properties[0].quantity_description}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Dinner</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Time (in 24-hrs format)</p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.dinner.properties[0].time}}
                                </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Menu with portion size </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.dinner.properties[0].quantity_description}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Snack 2</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> Time (in 24-hrs format)</p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.snack_2.properties[0].time}}
                                </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="egd-theme-text"> List of Snacks & drinks </p>
                            </div>
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.snack_2.properties[0].quantity_description}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Duration of sleep per day(in hours)</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.sleep.properties[0].quantity_string}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ui-g">
                <div class="ui-g-12">
                    <p class="egd-theme-text"><b>Water intake per day(in litres)</b></p>
                </div>
                <div class="ui-g">
                    <div class="ui-g-12">
                        <div class="ui-g">
                            <div class="ui-g-12">
                                <p class="format-lines description-text">
                                    {{this.dietConsultationData.dietFoodData.water.properties[0].quantity_string}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template> -->
    </div>

</div>